const strings = {
  en: {
    processing: {
      title: "Connecting with Google...",
      message: "Processing Google authentication...",
      authenticating: "Authenticating with Google...",
    },
    success: {
      titleNew: "Welcome to TA Connect!",
      titleReturning: "Welcome Back!",
      messageNew: "Welcome to TA Connect! Your account has been created successfully.",
      messageLogin: "Login successful! Redirecting to dashboard...",
      messageUserType: "Account created! Please select your user type to continue.",
      redirecting: "Redirecting to your dashboard...",
    },
    error: {
      title: "Authentication Failed",
      cancelled: "Google authentication was cancelled or failed.",
      noCode: "No authorization code received from Google.",
      failed: "Google authentication failed.",
      unexpected: "An unexpected error occurred during authentication.",
      server: "Server error. Please try again later.",
      heading: "Authentication Error",
    },
  },
  ar: {
    processing: {
      title: "الاتصال بـ Google...",
      message: "جارٍ معالجة مصادقة Google...",
      authenticating: "جارٍ المصادقة باستخدام Google...",
    },
    success: {
      titleNew: "مرحبًا بك في TA Connect!",
      titleReturning: "مرحبًا بعودتك!",
      messageNew: "مرحبًا بك في TA Connect! تم إنشاء حسابك بنجاح.",
      messageLogin: "تم تسجيل الدخول بنجاح! جارٍ التوجيه إلى لوحة التحكم...",
      messageUserType: "تم إنشاء الحساب! يرجى تحديد نوع المستخدم للمتابعة.",
      redirecting: "جارٍ التوجيه إلى لوحة التحكم...",
    },
    error: {
      title: "فشلت المصادقة",
      cancelled: "تم إلغاء مصادقة Google أو فشلت.",
      noCode: "لم يتم استلام رمز التفويض من Google.",
      failed: "فشلت مصادقة Google.",
      unexpected: "حدث خطأ غير متوقع أثناء المصادقة.",
      server: "خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقًا.",
      heading: "خطأ في المصادقة",
    },
  },
};

export default strings;
